import React from 'react'
import CentaCandidateReport from './centaCandidateReport'
import { useParams } from '@pankod/refine-react-router-v6'

const Ams_View_Report_Preview = () => {
    let { id } = useParams()
    return (
        <div>
            {id && <CentaCandidateReport candidate={id} preview={true} />}
        </div>
    )
}

export default Ams_View_Report_Preview
